/**
 * useLanguageSync Hook
 *
 * Subscribes to Zustand useSettingsStore language changes
 * and syncs them with i18next.
 *
 * Should be called once in App.tsx to maintain sync.
 */

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSettingsStore } from '@/shared/stores/useSettingsStore';

export function useLanguageSync(): void {
  const { i18n } = useTranslation();
  const language = useSettingsStore((state) => state.language);

  useEffect(() => {
    // Sync i18next language when Zustand store changes
    if (i18n.language !== language) {
      void i18n.changeLanguage(language);
    }
  }, [language, i18n]);
}
